import type { ThemeOptions } from '@mui/material/styles';

// typography styles: https://mui.com/customization/typography/
// zeplin templates: https://app.zeplin.io/project/5d493736066e193158b2d910/screen/63762b618ee52e6d81bb42aa
export const createTypography: () => ThemeOptions['typography'] = () => ({
  fontFamily: 'primary, primary Fallback',
  body1: {
    fontSize: '1rem',
    lineHeight: '1.375rem',
  },
  body3: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
  },
  h1: {
    fontSize: '2.625rem',
    lineHeight: '2.625rem',
  },
  h2: {
    fontSize: '1.75rem',
    lineHeight: '2rem',
  },
  h3: {
    fontSize: '1.5rem',
    lineHeight: '1.75rem',
  },
  h4: {
    fontSize: '1.313rem',
    lineHeight: '1.75rem',
  },
  h5: {
    fontSize: '1rem',
    lineHeight: '1.25rem',
  },
  h6: {
    fontSize: '0.813rem',
    lineHeight: '1.25rem',
  },
  caption: undefined,
  subtitle1: undefined,
  subtitle2: undefined,
  button: undefined,
  overline: undefined,
});
